import { render, staticRenderFns } from "./radish-left.vue?vue&type=template&id=799847ae"
import script from "./radish-left.vue?vue&type=script&lang=js"
export * from "./radish-left.vue?vue&type=script&lang=js"
import style0 from "./radish-left.vue?vue&type=style&index=0&id=799847ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports